@if (attributeGroupDetail$ | async) {
  <div>
    <form [formGroup]="form" novalidate (ngSubmit)="submit()">
      <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label class="mt-4">Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="name"
            type="text"
            required
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label class="mt-4">Description</label>
        <mat-form-field class="flex-40" >
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            formControlName="description"
            type="text"
            (click)="hasChanges()"
          ></textarea>
          @if (form.controls['description'].invalid) {
            <mat-error>Please enter a Description</mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </div>
}
